import React, { Fragment } from 'react';
import * as GlobalService from './global_services';
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    StackTrace.fromError(error).then(stackframes => {
      var stringifiedStack = stackframes.map(function (sf) {
        // console.log("sf :",sf);
        return sf.toString();
      }).join('\n');
      var errorData = {
        "activeTab": ($(".tab-list div.active h5").text() + "  " + $(".tab-list div.active p:first").text() + "  " + $(".tab-list div.active p:last").text()).trim(),
        "message": error.message,
        "stack": stringifiedStack,
        "errorInfo": stringifiedStack,
        "from": "errorBoundary"
      }
      GlobalService.LogBrowserTraces(JSON.stringify(errorData)).then(function (response) {
        console.log(response);
      });
    });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }
}